// extracted by mini-css-extract-plugin
export default {"QuestionList":"QuestionList_QuestionList__NttLu","name":"QuestionList_name__OTygq","author":"QuestionList_author__28F6R","type":"QuestionList_type__53Inc"};